import { Link } from 'react-router-dom';

const Blog = () => {
  const blogItems = [
    {
      id: 1,
      title: "The Rise of Algorithmic Trading in India : Why Smart Investors Are Adapting",
      image: "assets/images/blog/image-4.jpg",
      description: "Algorithmic trading is transforming how India trades. With markets becoming faster and data-driven, even traditional investors are shifting toward automation. Platforms like ours offer API-based execution, back-tested strategies, and low-latency systems, empowering traders to compete at institutional levels.",
      animationDuration: "800",
      link: "/the-rise-of-algorithmic-trading-in-india"
    },
    {
      id: 2,
      title: "How Pro Traders Cut Costs and Scale Profits with Smarter Brokerage Plans",
      image: "assets/images/blog/image-2.jpg",
      description: "In trading, every tick matters—and so does every rupee you save. At Asiatic Stock & Securities, we’ve reimagined brokerage for professionals who demand more from their platform.",
      animationDuration: "1000",
      link: "/traders-cut-costs-and-scale-profits"
    },
    {
      id: 3,
      title: "Building Confidence in the Age of Automation : Why Compliance Is Your Best Strategy",
      image: "assets/images/blog/image-3.jpg",
      description: "In today’s AI-driven markets, speed and automation dominate the headlines—but what truly sustains success is compliance and credibility. At Asiatic Stock & Securities, every strategy, order, and platform integration is built on SEBI-aligned governance, ensuring your trading remains transparent, secure, and fully compliant.",
      animationDuration: "1200",
      link: "/building-confidence-in-the-age-of-automation"
    }
  ];

  return (
    <div className="blog padding-top padding-bottom py-5">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2 className="text-uppercase">Blog</h2>
        </div>
        <div className="blog__wrapper">
          <div className="row g-4">
            {blogItems.map((item) => (
              <div className="col-sm-6 col-lg-4" key={item.id}>
                {/* Wrap the entire blog__item in a Link */}
                <Link to={item.link} className="text-decoration-none text-dark">
                  <div
                    className="blog__item"
                    data-aos="fade-up"
                    data-aos-duration={item.animationDuration}
                  >
                    <div className="blog__item-inner blog__item-inner--style2">
                      <div className="blog__thumb">
                        <img src={item.image} alt="blog Images" />
                      </div>
                      <div className="blog__content">
                        <h5 className="mt-3">{item.title}</h5>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
